function sendJson(url, data, httpMethod) {
	const headers = new Headers();
	headers.append('Content-Type', 'application/json');
	const options = {
		headers,
		method: httpMethod,
		mode: 'cors',
		cache: 'default',
		credentials: 'include',
		body: JSON.stringify(data)
	};

	return fetch(url, options)
		.then((response) => {
			if (response.status === 204) {
				return undefined;
			}
			return response.json();
		})
		.catch((e) => {
			console.log(`${e} for ${httpMethod} ${url}`);

			return Promise.reject(e);
		});
}
function postJson(url, data) {
	return sendJson(url, data, 'POST');
}

function postFile(url, file) {
	const form = new FormData();
	form.append('file', file);
	const options = {
		method: 'POST',
		credentials: 'include',
		body: form
	};
	return fetch(url, options)
		.then(response => response.json())
		.catch((e) => {
			return Promise.reject(e);
		});
}

function putJson(url, data) {
	return sendJson(url, data, 'PUT');
}

function postFormUrlEncoded(url, urlEncodedData) {
	const headers = new Headers();
	headers.append('Content-Type', 'application/x-www-form-urlencoded');

	const options = {
		headers,
		method: 'POST',
		mode: 'cors',
		cache: 'default',
		credentials: 'include',
		body: urlEncodedData
	};
	return fetch(url, options)
		.then(response => response.json())
		.catch((e) => {
			console.log(`Post url-encoded form failed. url=${url}, options=${urlEncodedData}, error:`, e);
			return Promise.reject(e);
		});
}

function createUrlParameters(data) {
	return Object.keys(data).map((key) => {
		const encodedKey = encodeURIComponent(key);
		const encodedDataKey = encodeURIComponent(data[key]);
		return `${encodedKey}=${encodedDataKey}`;
	}).join('&');
}

function getUrl(url, data) {
	if (data === undefined) {
		return url;
	}
	return `${url}?${createUrlParameters(data)}`;
}

function postObjectAsFormUrlEncoded(url, data) {
	return postFormUrlEncoded(url, createUrlParameters(data));
}

function fetchJson(url, data) {
	const headers = new Headers();
	headers.append('accept', 'application/json');
	const options = {
		headers,
		method: 'GET',
		credentials: 'include',
		cache: 'no-store'
	};

	return fetch(getUrl(url, data), options)
		.then(response => response.json());
}

export {
	fetchJson,
	postFormUrlEncoded,
	postJson,
	postFile,
	postObjectAsFormUrlEncoded,
	putJson
};



// WEBPACK FOOTER //
// ./mobile-core/src/core/ajax-json.js